function StationsListController($uibModal) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.sortType = 'name'; // set the default sort type
    ctrl.sortReverse = false; // set the default sort order
  };

  ctrl.toggleEditMode = ($event, station) => {
    $event.preventDefault();
    $event.stopPropagation();
    ctrl.editMode = true;
    ctrl.onToggle({
      $event: {
        editMode: true,
        station: station,
      },
    });
  };

  ctrl.openDeleteModal = ($event, station) => {
    $event.preventDefault();
    $event.stopPropagation();
    let modalInstance = $uibModal.open({
      component: 'deleteStationModal',
      backdrop: 'static',
      resolve: {
        station: function() {
          return station;
        },
      },
    });

    modalInstance.result.then(
      stationId => {
        // User pressed 'Yes' in the modal.
        ctrl.onDelete({
          $event: {
            stationId: stationId,
          },
        });
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.setSortType = column => {
    ctrl.sortType = column;
    ctrl.sortReverse = !ctrl.sortReverse;
  };

}

angular
  .module('pis-tool.module')
  .controller('StationsListController', StationsListController);
